import { footerGroups } from "@/mocks/home";

export default function Footer() {
  return (
    <footer className="bg-primary-800 text-background-100">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 py-12 md:grid-cols-2 lg:grid-cols-[1.6fr_1fr_1fr_1fr] md:py-14">
          {/* brand */}
          <div>
            <a href="#top" className="flex items-center gap-2.5 cursor-pointer">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className="ri-community-fill text-lg" />
              </span>
              <span className="font-heading text-2xl tracking-wide text-background-50">69吃瓜</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200/90">
              只做有始有终的网络热点「事件梳理」。从一张脉络图到一段完整时间线，
              前因后果逐步拆解、口径并列，让吃瓜也能吃得明明白白。
            </p>
            <p className="mt-4 flex items-center gap-2 text-xs text-background-300/80">
              <i className="ri-shield-check-line text-accent-400" />
              本站所有内容均基于公开渠道整理，仅供事件梳理参考。
            </p>
          </div>

          {/* link groups */}
          {footerGroups.map((g) => (
            <nav key={g.title}>
              <h4 className="font-label text-sm font-bold text-background-50">{g.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {g.items.map((it) => (
                  <li key={it}>
                    <a
                      href="#top"
                      className="inline-flex items-center gap-1.5 text-sm text-background-200/90 transition-colors hover:text-accent-300 cursor-pointer"
                    >
                      {it}
                      <i className="ri-arrow-right-up-line text-xs opacity-0 transition-opacity hover:opacity-100" />
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="flex flex-col items-center justify-between gap-3 border-t border-background-50/15 py-6 sm:flex-row">
          <p className="text-xs text-background-300/80">
            © 2026 69吃瓜 · 事件梳理与时间线 · 前因后果始末完整呈现
          </p>
          <div className="flex items-center gap-4 text-xs text-background-300/80">
            <a href="#top" className="hover:text-background-50 cursor-pointer">
              隐私说明
            </a>
            <span className="h-3 w-px bg-background-50/20" />
            <a href="#faq" className="hover:text-background-50 cursor-pointer">
              纠错入口
            </a>
            <span className="h-3 w-px bg-background-50/20" />
            <a href="#top" className="hover:text-background-50 cursor-pointer">
              意见反馈
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}